export const API_URL = process.env.REACT_APP_ENV === 'prod' ? "https://api.admissionpedia.com/api": "https://api.admissionpedia.dev/api"


